import { render, staticRenderFns } from "./sendsmsframe.vue?vue&type=template&id=52e6f2b5&"
import script from "./sendsmsframe.vue?vue&type=script&lang=js&"
export * from "./sendsmsframe.vue?vue&type=script&lang=js&"
import style0 from "./sendsmsframe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports